// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__NonCt","aboutInner":"About_aboutInner__lWTEB","avatarBox":"About_avatarBox__3d2mL","avatar":"About_avatar__RlGkU","aboutDesc":"About_aboutDesc__2Cwcm"};